import React, { useEffect, useState } from 'react';
import { notifyError } from '@/lib/errors';
import { RESEND_COOLDOWN_SECONDS } from '@/lib/emailTwoFA';

/** "Resend code" link for the email 2FA step. The screen opens right after a
 * code was sent, so it waits out the cooldown first, then re-sends on click
 * and starts counting again. */
export default function ResendCodeButton({ onResend, cooldownSeconds = RESEND_COOLDOWN_SECONDS, className = '', style }) {
  const [secondsLeft, setSecondsLeft] = useState(cooldownSeconds);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (secondsLeft <= 0) return undefined;
    const timer = setTimeout(() => setSecondsLeft((s) => s - 1), 1000);
    return () => clearTimeout(timer);
  }, [secondsLeft]);

  const resend = async () => {
    setSending(true);
    try {
      await onResend();
      setSecondsLeft(cooldownSeconds);
    } catch (err) {
      notifyError(err, 'Could not resend the code. Please try again.');
    } finally {
      setSending(false);
    }
  };

  const waiting = secondsLeft > 0;
  return (
    <button
      type="button"
      onClick={resend}
      disabled={waiting || sending}
      className={`w-full text-xs font-medium text-center disabled:opacity-60 disabled:cursor-not-allowed ${className}`}
      style={style}
      data-testid="2fa-resend"
    >
      {sending ? 'Sending…' : waiting ? `Resend code in ${secondsLeft}s` : 'Resend code'}
    </button>
  );
}
